import { Component, computed, output, signal } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { faSolidArrowDownAZ, faSolidArrowDownZA } from '@ng-icons/font-awesome/solid';

@Component({
    selector: 'app-glossary-sorting',
    imports: [NgIcon],
    providers: [provideIcons({ faSolidArrowDownAZ, faSolidArrowDownZA })],
    templateUrl: './glossary-sorting.component.html',
    styleUrl: './glossary-sorting.component.scss'
})
export class GlossarySortingComponent {
  protected sortAscending = signal(true);
  protected text = computed(() => this.sortAscending() ? 'A-Z': 'Z-A');
  protected update = output<boolean>();

  protected switch () {
    this.sortAscending.set(!this.sortAscending());
    this.update.emit(this.sortAscending());
  }
}
